(() => {
    const chatbot = document.getElementById('omnichannel-chatbot');

    if (!chatbot) {
        return;
    }

    const enabled = chatbot.dataset.enabled === 'true';
    const device = chatbot.dataset.device || 'all';
    const appId = chatbot.dataset.appId;

    if (!appId) {
        return;
    }

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    let shouldRender = enabled;

    if (!enabled) {
        switch (device) {
            case 'mobile':
                // exclude mobile => render only in desktop
                shouldRender = !isMobile;
                break;

            case 'desktop':
                // exclude desktop => render only in mobile
                shouldRender = isMobile;
                break;

            case 'all':
            default:
                // always exclude
                shouldRender = false;
                break;
        }
    }

    if (!shouldRender) {
        return;
    }

    
    const a = document.createElement('a');
    a.setAttribute('href', 'javascript:;');
    a.setAttribute('id', 'easychat-floating-button');
    const img = document.createElement('img');
    img.src = 'https://chat-plugin.easychat.co/icon.svg';
    a.appendChild(img);
    const span = document.createElement('span');
    span.setAttribute('id', 'easychat-unread-badge');
    span.setAttribute('style', 'display: none');
    const d1 = document.createElement('div');
    d1.setAttribute('id', 'easychat-close-btn');
    d1.setAttribute('class', 'easychat-close-btn-close');
    const d2 = document.createElement('div');
    d2.setAttribute('id', 'easychat-chat-dialog');
    d2.setAttribute('class', 'easychat-chat-dialog-close');
    const ifrm = document.createElement('iframe');
    ifrm.setAttribute('id', 'easychat-chat-dialog-iframe');
    ifrm.setAttribute(
        'src',
        `https://client-chat.easychat.co/?appkey=${appId}&lang=zh-Hant`
    );
    ifrm.style.width = '100%';
    ifrm.style.height = '100%';
    ifrm.style.frameborder = '0';
    ifrm.style.scrolling = 'on';
    d2.appendChild(ifrm);
    document.body.appendChild(a);
    document.body.appendChild(span);
    document.body.appendChild(d1);
    document.body.appendChild(d2);

    const script = document.createElement('script');
    script.defer = true;
    script.id = "Omnichannel_Chatbot";
    script.src = "https://chat-plugin.easychat.co/easychat.js";
    chatbot.appendChild(script);
})();